import clsx from 'clsx';

import type { RecurrencePeriod } from '../DRecurrence';
import { RDateTimeField } from './RDateTimeField';

const MODES: { value: RecurrencePeriod; label: string; suffix: string }[] = [
  { value: 'day', label: 'День', suffix: 'день' },
  { value: 'week', label: 'Неделя', suffix: 'неделю' },
  { value: 'month', label: 'Месяц', suffix: 'месяц' },
];

/** Панель регулярной задачи из макета: режим, шаг, первая задача и «до». */
export function RRepeat({
  isOpen,
  disabled,
  period,
  setPeriod,
  firstAt,
  setFirstAt,
  everyCount,
  setEveryCount,
  untilAt,
  setUntilAt,
}: {
  isOpen: boolean;
  disabled?: boolean;
  period: RecurrencePeriod;
  setPeriod: (p: RecurrencePeriod) => void;
  firstAt: string;
  setFirstAt: (v: string) => void;
  everyCount: number;
  setEveryCount: (n: number) => void;
  untilAt: string;
  setUntilAt: (v: string) => void;
}) {
  if (!isOpen) {
    return null;
  }

  const suffix = MODES.find((m) => m.value === period)?.suffix ?? 'день';

  return (
    <div className="mt-[16px] rounded-[16px] bg-[#F6F7FA] px-[18px] py-[16px]">
      <div className="flex flex-wrap items-center gap-x-[18px] gap-y-[12px]">
        <span className="text-[12px] text-[rgba(20,30,49,0.7)]">
          Повторяемость
        </span>
        <span className="flex items-center gap-[8px]">
          {MODES.map((m) => {
            const on = period === m.value;
            return (
              <button
                key={m.value}
                type="button"
                disabled={disabled}
                onClick={() => setPeriod(m.value)}
                className={clsx(
                  'border-b px-[8px] pb-[4px] pt-[3px] text-[12px]',
                  on
                    ? 'border-[#57B792] font-bold text-[#57B792]'
                    : 'border-[rgba(59,77,127,0.25)] font-medium text-[rgba(20,30,49,0.6)]',
                  disabled && 'cursor-not-allowed opacity-50'
                )}
              >
                {m.label}
              </button>
            );
          })}
        </span>

        <span className="min-w-[12px] flex-1" />

        <span className="flex items-center gap-[10px]">
          <span className="text-[12px] text-[rgba(20,30,49,0.7)]">Каждый</span>
          <input
            value={Number.isFinite(everyCount) ? everyCount : 1}
            disabled={disabled}
            onChange={(e) => {
              const n = parseInt(e.target.value || '1', 10);
              setEveryCount(
                Number.isFinite(n) ? Math.max(1, Math.min(365, n)) : 1
              );
            }}
            className={clsx(
              'w-[34px] border-b border-[rgba(59,77,127,0.3)] bg-transparent pb-[4px] pt-[3px]',
              'text-center text-[12px] font-bold text-[#141E31] outline-none',
              disabled && 'cursor-not-allowed opacity-50'
            )}
            aria-label="Шаг повторения"
          />
          <span className="border-b border-[rgba(59,77,127,0.3)] px-[6px] pb-[4px] pt-[3px] text-[12px] font-semibold text-[#141E31]">
            любой
          </span>
          <span className="text-[12px] text-[rgba(20,30,49,0.55)]">
            {suffix}
          </span>
        </span>
      </div>

      <div className="mt-[16px] flex flex-wrap items-start gap-x-[18px] gap-y-[12px]">
        <span className="text-[12px] text-[rgba(20,30,49,0.7)]">
          Создать первую задачу
        </span>
        <RDateTimeField
          title="Создать первую задачу"
          value={firstAt}
          onChange={setFirstAt}
          disabled={disabled}
          width={132}
        />

        <span className="min-w-[12px] flex-1" />

        <span className="flex flex-col items-start gap-[4px] min-[620px]:items-end">
          <span className="flex items-center gap-[10px]">
            <span className="text-[12px] text-[rgba(20,30,49,0.7)]">
              Повторять до
            </span>
            <RDateTimeField
              title="Повторять до"
              value={untilAt}
              onChange={setUntilAt}
              disabled={disabled}
              width={132}
            />
          </span>
          <span className="text-[10px] text-[rgba(20,30,49,0.4)]">
            *активируется только при заполнении
          </span>
        </span>
      </div>
    </div>
  );
}
